import { useState, useEffect } from "react";
import { buscarAnunciosService } from "../../../services/buscarAnunciosService";
import { buscarUsuarioByIdService } from "../../../services/buscarUsuarioByIdService";
import { Usuario } from "../../../interfaces/Usuario";
import { formatDate } from "../../../uteis/dateUtils";

export const useBuscarAnuncios = () => {
  const [anuncios, setAnuncios] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const buscar = async () => {
    setIsLoading(true);

    const data = await buscarAnunciosService();

    console.log("Dados recebidos:", data);

    const anuncioFormatado = await Promise.all(
  data.map(async (item: any) => {
    const user = await buscarUsuario(item.CotasUsuariosTable.usuarioId);

    return {
      id: item.id || "",
      proprietario: user.nomeCompleto,
      celular: user.celular, // ✅ novo campo
      empreendimento:
        item.CotasUsuariosTable.CotaTable.AptoTable.EmpreendimentoTable.nome,
      dataAnuncio: formatDate(item.dataAnuncio),
      dataInativacaoAnuncio: formatDate(item.dataInativacaoAnuncio),
      active: item.active ? "Sim" : "Não",
    };
  })
);

    setAnuncios(anuncioFormatado);
    setIsLoading(false);
  };

  useEffect(() => {
    buscar();
  }, []);

  const buscarUsuario = async (usuarioId: number) => {
    const usuario: Usuario = await buscarUsuarioByIdService(usuarioId);

    return {
    nomeCompleto: `${usuario.nome ?? ""} ${usuario.sobrenome ?? ""}`.trim(),
    celular: (usuario as any).celular ?? "N/A", // ajuste se seu Usuario já tiver celular tipado
  };
  };

  return { anuncios, isLoading, buscar };
};
